;(() => {
  const modal = document.querySelector('section#modal')
  document
    .querySelectorAll('.product-more-images figure.video')
    .forEach((button) => {
      button.addEventListener('click', function () {
        modal.classList.add('active', 'video')
        modal.querySelector('main.wrapper').innerHTML =
          this.querySelector('.asset').innerHTML

        setTimeout(() => {
          const video = modal.querySelector('video')
          video.play()
        }, 100)
      })
    })
})()
